export const ORDERS_STATE_IS_LOADING = 'ORDERS_STATE_IS_LOADING';
export const ORDER_STATE_IS_LOADING = 'ORDER_STATE_IS_LOADING';
